import { all, call, takeLatest } from '@redux-saga/core/effects';
import axios from 'axios';
import { fork, put } from 'redux-saga/effects';
import { UPDATE_RECEIPT_REQUEST, UPDATE_RECEIPT_SUCCESS, UPDATE_RECEIPT_FAILURE, COMMON_FAILURE } from '../../actions';

import { receiptService } from '../../services';

export type updateReceiptActionType = {
  type: typeof UPDATE_RECEIPT_REQUEST;
  memberId: string;
  targetMonth: number;
  paymentDate: string;
  recipientName: string;
  clauseTitle: string | null;
  history: string[];
};

function* updateReceipt(action: updateReceiptActionType): Generator<unknown> {
  try {
    const res: any = yield call(receiptService(action).updateReceipt);
    yield put({
      type: UPDATE_RECEIPT_SUCCESS,
      res,
    });

    /*
    const header = res.headers['content-disposition'];
    const filenameMatch = header.match(/filename="(.+)"/);
    let name = filenameMatch ? filenameMatch[1] : 'receipt.pdf';
    name = decodeURIComponent(escape(name));
    // const nameIndex = res.headers['content-disposition'].indexOf('filename=');
    // const name: string = res.headers['content-disposition'].substring(nameIndex + 9, nameIndex.length);
    const url = URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', name);
    document.body.appendChild(link);
    link.click();
    URL.revokeObjectURL(url);
    link.remove();
    */
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const data = error.response?.data;

      /*
      if (error.response?.data instanceof Blob) {
        const text = (yield call([error.response.data, error.response.data.text])) as string;
        const parsed = JSON.parse(text);
        data = parsed;
      }
      */

      yield put({
        type: UPDATE_RECEIPT_FAILURE,
        error: data,
      });
      yield put({
        type: COMMON_FAILURE,
        error: data,
      });

      if (error.response && error.response.status >= 500) {
        action.history.push('/systemError');
      }
    } else {
      action.history.push('/systemError');
    }
  }
}

function* watchUpdateReceipt() {
  yield takeLatest(UPDATE_RECEIPT_REQUEST, updateReceipt);
}
export default function* updateReceiptSaga(): Generator<unknown> {
  yield all([fork(watchUpdateReceipt)]);
}
